import { graphql } from 'src/graphql';

export const BookingSegmentFills = graphql(`
  query BookingSegmentFills($input: BookingSegmentFillsInput!) {
    bookingSegmentFills(input: $input) {
      segments {
        _id
        quota
        filled
        completed
        segment {
          _id
          name
          enabled
        }
      }
      unassigned {
        quota
        filled
        completed
      }
    }
  }
`);
